import onCloseInlineCompose from './onCloseInlineCompose';
import { getStore } from '../store/composeStore';
import * as mailModuleOrchestrator from 'owa-mail-module-orchestrator';
import { closeAllSxS } from 'owa-sxs-store';
import { action } from 'satcheljs/lib/legacy';
export default action('pendCompose')(function pendCompose() {
    var state = getStore();
    if (state.defaultViewState && !state.pendingViewState) {
        if (state.defaultViewState.isInlineCompose) {
            onCloseInlineCompose(state.defaultViewState.conversationId);
        }
        else {
            mailModuleOrchestrator.lazyOnCloseCompose.importAndExecute();
        }
        state.pendingViewState = state.defaultViewState;
        state.defaultViewState = null;
        closeAllSxS('pendCompose');
    }
});
//# sourceMappingURL=pendCompose.js.map